import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { ToastContainer } from "react-toastify";

const AddressFormComponent = (props) => {
    const { register, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm({
        defaultValues: props.editData || {}
    });

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const selectedCountry = watch("country");
    const selectedState = watch("state");

    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList.map(country => ({
            value: country.isoCode,
            label: country.name
        })));
    }, []);

    useEffect(() => {
        if (selectedCountry) {
            const stateList = State.getStatesOfCountry(selectedCountry);
            setStates(stateList.map(state => ({
                value: state.isoCode,
                label: state.name
            })));
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            const cityList = City.getCitiesOfState(selectedCountry, selectedState);
            setCities(cityList.map(city => ({
                value: city.name,
                label: city.name
            })));
        }
    }, [selectedState, selectedCountry]);

    useEffect(() => {
        if (props.editData) {
            reset(props.editData);
        }
    }, [props.editData, reset]);

    useEffect(() => {
        if (props.customerId) {
            setValue('customer_id', props.customerId);
        }
    }, [props.customerId, setValue]);
    
    const onFormSubmit = async (data) => {
        const isSuccess = await props.onSubmit(data); // make onSubmit return a success flag
        if (!isSuccess) return;
        reset();
        props.toggleView(props.tab, 'card');
    };

    const handleCancel = () => {
        props.toggleView(props.tab, 'card');
    };

    const fields = [
        { name: 'address', label: 'Address', type: 'text' },
        { name: 'country', label: 'Country', type: 'react-select', options: countries },
        { name: 'state', label: 'State', type: 'react-select', options: states },
        { name: 'city', label: 'City', type: 'react-select', options: cities },
        { name: 'zipcode', label: 'Zip Code', type: 'text' },
        { name: 'customer_id', type: 'hidden', defaultValue: props.customerId }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="card row p-4">
                    <div className="card-header">
                        <h2 className="header-title">{props.company}</h2>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onFormSubmit)}>
                            <div className="row">
                                {fields.map(({ name, label, type, options, defaultValue }) => {
                                    if (type === 'react-select') {
                                        return (
                                            <div key={name} className="col-12 col-md-6 mb-4">
                                                <label className="form-label">{label}</label>
                                                <Select
                                                    {...register(name, { required: `${label} is required.` })}
                                                    options={options}
                                                    onChange={selectedOption => {
                                                        // Update the form value when the user selects an option
                                                        setValue(name, selectedOption?.value);
                                                    }}
                                                    getOptionLabel={e => e.label}
                                                    getOptionValue={e => e.value}
                                                    value={options.find(option => option.value === watch(name))}
                                                />
                                                {errors[name] && <small className="text-danger">{errors[name].message}</small>}
                                            </div>
                                        );
                                    } else if (type === 'text') {
                                        return (
                                            <div key={name} className="col-12 col-md-6 mb-4">
                                                <label className="form-label">{label}</label>
                                                <input
                                                    type={type}
                                                    {...register(name, {
                                                        required: `${label} is required.`,
                                                        ...(name === 'zipcode' && {
                                                            pattern: {
                                                                value: /^\d{6}$/,
                                                                message: 'Zip Code must be exactly 6 digits.'
                                                            }
                                                        })
                                                    })}
                                                    className="form-control"
                                                />
                                                {errors[name] && <small className="text-danger">{errors[name].message}</small>}
                                            </div>
                                        );
                                    } else if (type === 'hidden') {
                                        return (
                                            <input
                                                key={name}
                                                type="hidden"
                                                {...register(name)}
                                                defaultValue={defaultValue}
                                            />
                                        );
                                    }
                                    return null;
                                })}
                            </div>

                            <div className="row d-flex justify-content-end">
                                <div className="col-auto">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger me-2"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-sm btn-primary">
                                        {props.editData?.id ? 'Update' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default AddressFormComponent;
